import { openMetadataApiClient } from '@/shared/api/core/axios-instance';

import type { SubDomainSearchResponse } from '@/entities/domain/domain/types';

export type SubDomainsParams = {
  parentFqn: string;
  from?: number;
  size?: number;
  includeDeleted?: boolean;
};

/**
 * 상위 도메인의 하위 도메인 목록을 검색합니다.
 *
 * @param params - 검색 파라미터
 * @param params.parentFqn - 상위 도메인의 FQN
 * @param params.from - 검색 시작 위치 (기본값: 0)
 * @param params.size - 검색 결과 개수 (기본값: 50)
 * @param params.includeDeleted - 삭제된 도메인 포함 여부 (기본값: false)
 * @returns 하위 도메인 검색 결과
 */
export const fetchSubDomains = async ({
  parentFqn,
  from = 0,
  size = 50,
  includeDeleted = false,
}: SubDomainsParams): Promise<SubDomainSearchResponse> => {
  try {
    const query = `** AND (parent.fullyQualifiedName:"${parentFqn}")`;

    const response = await openMetadataApiClient.get<SubDomainSearchResponse>('/search/query', {
      params: {
        q: query,
        from,
        size,
        index: 'domain_search_index',
        deleted: includeDeleted,
        track_total_hits: true,
      },
    });

    return response.data;
  } catch (error) {
    console.error('Failed to fetch sub-domains:', error);
    throw error;
  }
};
